import * as Blockly from 'blockly/core';
import { useBlockFunctionStore } from '@/stores/useBlockFunctionStore';
import { getInitialXml } from '@/stores/useBoardEditorFileStore';
import type { BoardType } from '@/stores/useBoardEditorStore';
import { syncAllBoardBlocks } from '@/(routers)/boards/editor/block/blockFactory';
import { registerBoolPreset } from '@/(routers)/boards/editor/block/definitions/blocks/variable/var_get_bool_preset';
import { registerNumberPreset } from '@/(routers)/boards/editor/block/definitions/blocks/variable/var_get_number_preset';
import { registerStringPreset } from '@/(routers)/boards/editor/block/definitions/blocks/variable/var_get_string_preset';

export function loadWorkspace(workspace: Blockly.WorkspaceSvg, xmlText: string, board: BoardType): void {
    Blockly.Events.disable();
    try {
        workspace.clear();
        const validXmlText = xmlText || getInitialXml(board);
        const dom = Blockly.utils.xml.textToDom(validXmlText);

        const functionsEl = dom.querySelector('functions');
        if (functionsEl) {
            try {
                const fns = JSON.parse(functionsEl.textContent ?? '[]');
                useBlockFunctionStore.getState().setFunctions(fns);
            } catch {}
            functionsEl.remove();
        } else {
            useBlockFunctionStore.getState().setFunctions([]);
        }

        Blockly.Xml.clearWorkspaceAndLoadFromXml(dom, workspace);
    } catch (e) {
        workspace.clear();
        const dom = Blockly.utils.xml.textToDom(getInitialXml(board));
        Blockly.Xml.clearWorkspaceAndLoadFromXml(dom, workspace);
    } finally {
        Blockly.Events.enable();
    }

    registerNumberPreset(workspace);
    registerStringPreset(workspace);
    registerBoolPreset(workspace);

    syncAllBoardBlocks(workspace, board, false);
}
